import React, { useState } from 'react';
import Image from 'next/image';
import styles from './index.module.less';
import { commonImgPath } from '@/shared/app-common';
import { Button, message } from 'antd';
import AccountModal from '../AccountModal';
import { accountFakeSearch } from '@/lib/service';
import { FakeSearchModel } from '@/types/home';
import { useTranslation } from 'next-i18next';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';

export default function TopView() {
  const { t } = useTranslation();
  const [currentModal, setCurrentModal] = useState<FakeSearchModel>(null);
  const [inputVal, setInputVal] = useState('');
  const [loading, setLoading] = useState(false);

  const loadData = () => {
    if (loading) {
      return;
    }
    setLoading(true);

    accountFakeSearch(inputVal)
      .then((res) => {
        if (res?.code === 0) {
          setCurrentModal(res?.data ?? null);
        } else {
          message.error(res?.message);
        }
      })
      .catch((err) => {
        message.error(err?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSubmit = () => {
    if (inputVal?.length > 0) {
      ga_logEvent(EventName.input_username);
      loadData();
    } else {
      message.error(t('Please enter the Twitter @username'));
    }
  };

  return (
    <>
      <h1 style={{ display: 'none', width: '0', height: '0', overflow: 'hidden' }}>Impersonation Account Removal</h1>
      <div className={styles.container}>
        <div className={styles.desktopView}>
          <div className={styles.content}>
            <div className={styles.title}>
              {t('Impersonation')}
              <br />
              {t('Account')} <span className={styles.highlight}>{t('Removal')}</span>
            </div>
            <p className={styles.description}>{t('FAKE_ACCOUNT_DESC')}</p>
            <div className={styles.inputGroup}>
              <input
                placeholder={t('Enter the Twitter @username')}
                className={styles.emailInput}
                // defaultValue={inputVal}
                value={inputVal}
                onChange={(e) => setInputVal(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setInputVal(e.currentTarget.value);
                    onSubmit();
                  }
                }}
              />
              <Button type="primary" className={styles.submitButton} loading={loading} onClick={onSubmit}>
                {t('Spot Now')}
              </Button>
            </div>
          </div>
          <div className={styles.illustration}>
            <Image
              src={`${commonImgPath}/remove-fake-account-top-icon.webp`}
              alt="Impersonation Removal Illustration"
              width={400}
              height={400}
              layout="responsive"
              priority
              fetchPriority="high"
            />
          </div>
        </div>
        <div className={styles.mobileView}>
          <div className={styles.mobileTitle}>
            {t('Impersonation')}
            <br />
            {t('Account')} <span className={styles.highlight}>{t('Removal')}</span>
          </div>
          <p className={styles.mobileDescription}>
            {t(
              "Defend your identity from impersonators. Erase fake accounts and protect your brand's reputation with confidence.",
            )}
          </p>
          <div className={styles.mobileIllustration}>
            <Image
              src={`${commonImgPath}/remove-fake-account-top-icon.webp`}
              alt="Impersonation Removal Illustration"
              width={300}
              height={300}
              layout="responsive"
              priority
              fetchPriority="high"
            />
          </div>
          <div className={styles.inputGroup}>
            <input
              placeholder={t('Enter the Twitter @username')}
              className={styles.emailInput}
              // defaultValue={inputVal}
              value={inputVal}
              onChange={(e) => setInputVal(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setInputVal(e.currentTarget.value);
                  onSubmit();
                }
              }}
            />
            <Button type="primary" className={styles.submitButton} loading={loading} onClick={onSubmit}>
              {t('Spot Now')}
            </Button>
          </div>
        </div>
      </div>
      {currentModal && <AccountModal currentModel={currentModal} closeAction={() => setCurrentModal(null)} />}
    </>
  );
}
